import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_IMAGE } from "./data/media";
function addHeadLink(attrs: Record<string, string>) {
  const link = document.createElement("link");
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value));
  document.head.appendChild(link);
}

// Warm up the font + image origins and prioritise the hero image (LCP element).
addHeadLink({
  rel: "preconnect",
  href: "https://fonts.googleapis.com"
});
addHeadLink({
  rel: "preconnect",
  href: "https://fonts.gstatic.com",
  crossorigin: ""
});
addHeadLink({
  rel: "preconnect",
  href: "https://cdn.magicpatterns.com"
});
addHeadLink({
  rel: "preload",
  as: "image",
  href: HERO_IMAGE,
  fetchpriority: "high"
});
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-257" data-mp="2twsa0264fq5n" />);
}